// noinspection JSSuspiciousNameCombination

/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useEffect, useState } from 'react'
import { Image,
FlatList,
Text,
TouchableOpacity,
View,
SafeAreaView,
Dimensions,
Platform,
Animated} from 'react-native';
import {
CatalogUpdate,
FullScreenImageLoader} from '../../components';
import {DeviceDetector } from '../../utilities';
import { Firestore, Crashlytics }from '../../firebase/config';
import styles from './styles';
import { Icon } from 'react-native-elements';
import { LinearGradient } from 'expo-linear-gradient';

export default function SingleCatalog(props) {
    const [catalogUpdates, setCatalogUpdates] = useState([]);
    const [views, setViews] = useState('');
    const [loading, setLoading] = useState(true);
    const [catalog, setCatalog] = useState(null);
    const animatedValue = new Animated.Value(0);
    const { navigation } = props;
    const user = props.extraData.user.id;
    const isConnected = props.extraData.networkStatus.isConnected;
    const catalogID = props.route.params.catalog;
    const catalogsRef = Firestore.collection('Files').doc('Catalogs').collection('Empire Catalogs').doc(catalogID);
    const updatesRef = Firestore.collection('Updates');
    const userViewsRef = Firestore.collection('users').doc(user).collection('Viewed');
    const AnimatedFlatList = Animated.createAnimatedComponent(FlatList);


    //Get Catalog
    useEffect(() => {
            catalogsRef
                .get()
                .then((doc) => {
                    const catalogData = {
                        image: doc.data().image,
                        flipbook: doc.data().flipbook,
                        title: doc.data().title,
                        description: doc.data().description,
                        productLine: doc.data().productLine,
                    }
                    catalogData.id = doc.id
                    setCatalog(catalogData);
                })
                .catch((err) => {
                    console.error("Error getting catalog data: ", err);
                    Crashlytics.sendError(error);
                })
        },
        []);

    //sets nav options
    //gets user views
    useEffect(() => {
    if (catalog) {
    navigation.setOptions({
    title: catalog.title,
    headerRight: () => (
    <TouchableOpacity
    style={{ position: 'absolute', right: 15 }}
    onPress={() => {
    navigation.navigate('Activity Feed', {catalogID: catalogID})}}>
    <Icon
     name='fireplace'
     type='material-community'
     color='lightgray'
     size={30}
     />
     </TouchableOpacity>
     ),
     })
     const subscriber = userViewsRef
                .where('productLine', '==', catalog.productLine)
                    .onSnapshot(
                            querySnapshot => {
                            const allViews = []
                            querySnapshot.forEach(doc => {
                                const view = {
                                id: doc.id,
                                favorite: doc.data().favorite
                                }
                                allViews.push(view)
                            })
                            setViews(allViews);
                        },
                        error => {
                        console.error("Error getting user views: ", error);
                        Crashlytics.sendError(error);
                        }
                    )
                    return () => subscriber();
              }
            }, [catalog]);
/*
  /*
  Device Orientation Changes:
  Sets Scroll Enabled | True / False
  If Portrait: Scroll Enabled = False
  If Landscape: Scroll Enabled = True
*/
      const isLandscape = () => {
        const dim = Dimensions.get('screen');
        return dim.height < dim.width;
      };
 const [landscape, setLandscape] = useState(isLandscape());

  //Listens for changes in device orientation.
    useEffect(async () => {
    const isDesktop = await DeviceDetector.isDesktop();
    if (isDesktop) {
    setLandscape(false);
    return;
    }
      const callback = () => setLandscape(isLandscape());
      Dimensions.addEventListener('change', callback);
      return () => {
        Dimensions.removeEventListener('change', callback);
      };
    }, []);


    useEffect(() => {
    if (landscape) {
    switch(landscape) {
    case true:
    snapAnimationMax();
    break;
    case false:
    snapAnimationMin();
    break;
    return;
    }
    }
    },[landscape])

    useEffect(() => {
    if (!landscape) {return;}
    setTimeout(() => {
    snapAnimationMax();
    },1000)
    },[loading])


//gets catalog updates
    useEffect(() => {
    if (catalog) {
    const subscriber = updatesRef
                          .where('productLine', '==', catalog.productLine)
                          .orderBy('timestamp', 'desc')
                          .limit(20)
                              .onSnapshot(
                                      querySnapshot => {
                                      const allUpdates = []
                                      querySnapshot.forEach(doc => {
                                          const update = doc.data()
                                           const viewed = views.find(o => o.id === doc.id);
                                          let viewedStatus = false;
                                          let favorite = false;
                                           if (viewed) {
                                               viewedStatus = true;
                                               favorite = viewed.favorite? (viewed.favorite) : false;
                                           }
                                          update.viewed = viewedStatus
                                          update.favorite = favorite
                                          update.id = doc.id
                                          allUpdates.push(update)
                                      })
                                      setCatalogUpdates(allUpdates)
                                      setLoading(false)
                                  },
                                  error => {
                                  console.error("Error getting catalog updates: ", error);
                                  Crashlytics.sendError(error);
                                  }
                              )
                              return () => subscriber();
    }},[views])


      const renderCatalogUpdates = ({item, index}) => {
      return (
      <CatalogUpdate
       id={item.id}
       catalog={item.catalog}
       date={item.date}
       title={item.title}
       description={item.description}
       viewed={item.viewed}
       favorite={item.favorite}
       />
      )
      }

  const viewCatalog = () => {
    return navigation.navigate('ViewCatalog', {catalogID: catalog.id})
  }

const emptyList = () => {
    return (
    <SafeAreaView style={styles.updateContainerEmpty}>
    <View style={styles.textIcon}>
    <View>
    <Text style={styles.iconTextEmptyList}>All Caught Up!</Text>
    <Text style={styles.iconTextEmptyList}>No Unread Updates</Text>
    </View>
    <Icon name="verified" iconType="material" color="white" size={50} />
    </View>
    </SafeAreaView>
    )
    }

     const emptyListNoNetwork = () => {
        return (
        <SafeAreaView style={styles.updateContainerEmpty}>
        <View style={styles.textIcon}>
        <Image
        source={require('../../../assets/iconOffline.png')}
        />
        <Text style={{color: 'white'}}>Check Internet Connection</Text>
        </View>
        </SafeAreaView>
        )
        }


    const translateYHEADER = animatedValue.interpolate({
        inputRange: [0, 1],
        outputRange: [0, -300], //[0, -250]
        extrapolate: 'clamp',
    });


    const translateY = animatedValue.interpolate({
        inputRange: [0, 1],
        outputRange: [0, -100], //[0, -100]
        extrapolate: 'clamp',
    });

    const translateYBtn = animatedValue.interpolate({
        inputRange: [0, 1],
        outputRange: [0, -20], //[0, -20]
        extrapolate: 'clamp',
    });


    const translateYImage = animatedValue.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 220], //[0, 200]
        extrapolate: 'clamp',
    });


    const translateX = animatedValue.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 70], //[0, 100]
        extrapolate: 'clamp',
    });

    const scaleImage = animatedValue.interpolate({
        inputRange: [0, 1],
        outputRange: [1, .5], //[1, .5]
        extrapolate: 'clamp',
    });

    const scaleText = animatedValue.interpolate({
        inputRange: [0, 1],
        outputRange: [1, .85], //[1, .85]
        extrapolate: 'clamp',
    });

//Sets animation level to 0
 const snapAnimationMin =  () => {
 return Animated.timing(animatedValue, {
 toValue: 0,
 duration: 10000, // 1 seconds
 useNativeDriver: true,
 }).start();
 }

 //Sets animation level to 100
 const snapAnimationMax =  () => {
       return Animated.timing(animatedValue, {
       toValue: 100,
       duration: 10000, //1 seconds
       useNativeDriver: true,
     }).start();
  }

  const animate = Animated.event(
  [{nativeEvent: {contentOffset: {y: animatedValue}}}],
  {useNativeDriver: true} // <-- Add this
  )


  if (loading) {
    return (
    //<Loader />
       <FullScreenImageLoader />
    )
  }


  return (
  <View style={styles.container}>
  <LinearGradient
  colors={['black', '#590000']}
  locations={[.1,1]}
  style={{flex: 1}}>
  {catalog && catalogUpdates && (
  <>
  <SafeAreaView style={styles.container}>
        	    <AnimatedFlatList
        	    style={{width: "90%", alignSelf: 'center'}}
              	contentContainerStyle={[
              	{marginTop:landscape? (170) : (480)}, //470 / 200 | 170 / 470
              	{paddingBottom: landscape? (170) : (500)}, //470 / 200 | 170 / 470
              	]
              	}
              	showsVerticalScrollIndicator={false}
              	scrollEventThrottle={1} // <-- Use 1 here to make sure no events are ever missed
              	onScroll={landscape? null : (animate)}
              	//onScrollEndDrag={() => {snapAnimation()}}
                //onMomentumScrollEnd={() => {snapAnimationMax()}}
                ListEmptyComponent={isConnected? emptyList : emptyListNoNetwork}
              	data={catalogUpdates}
              	renderItem={renderCatalogUpdates}
              	keyExtractor={(item) => item.id}
              	/>
              	  </SafeAreaView>
      	<Animated.View style={[styles.headerWrapper, {transform: [{translateY: translateYHEADER}]}]}>
      	<Animated.View style={{transform: [{translateX: translateY}, {translateY: translateYImage}, {scale: scaleImage}]}}>
          <TouchableOpacity
          style={Platform.OS === 'android'?
          [
          styles.shadowAndroid,
          {transform: [{scale: scaleImage}]}
          ]
          :
          [
          styles.shadow,
          {transform: [{scale: scaleImage}]}
          ]
          }
          onPress={() => {viewCatalog()}}>
          <Animated.Image
          transition={true}
          source={{uri: catalog.image}}
          resizeMode='contain'
          style={{
          height: 300,
          aspectRatio: 3/4,
          }}
          />
          </TouchableOpacity>
          </Animated.View>


          <Animated.View style={{transform: [{translateX: translateX}, {scale: scaleText}]}}>
          <Animated.Text style={styles.catalogTitle}>{catalog.title}</Animated.Text>
          <Animated.Text style={styles.catalogDescription}>{catalog.description}</Animated.Text>
          </Animated.View>


          <Animated.View style={{transform: [{translateX: translateX }, {translateY: translateYBtn}, {scale: scaleText}]}}>
          <TouchableOpacity
          onPress={() => viewCatalog()}
          >
          <View style={styles.viewCatalogButtonContainer}>
          <Text style={styles.viewCatalogButtonText}>View Catalog</Text>
          </View>
          </TouchableOpacity>
          </Animated.View>
      	</Animated.View>
      	</>
  )}
  </LinearGradient>
  </View>
  )
}